import React, { FC } from "react";
import { useSelector } from "react-redux";

import { InvoiceHeaderForm } from "./InvoiceHeaderForm";
import { InvoiceItemsForm } from "./InvoiceItemsForm";
import { InvoiceSummary } from "./InvoiceSummaryForm";
import { InvoiceWalletList } from "./InvoiceWalletList";
import { selectInvoice, selectStep } from "../../../store/reducers/invoice";
import { InvoiceStatus } from "../../../types/InvoiceTypes";

export const ContentWrapper: FC = () => {
  const step = useSelector(selectStep);
  const invoice = useSelector(selectInvoice);

  if (!invoice) {
    return <></>;
  }

  const { status } = invoice;

  if (status === InvoiceStatus.DRAFT) {
    if (step === 1) {
      return <InvoiceHeaderForm />;
    }

    if (step === 2) {
      return <InvoiceItemsForm />;
    }

    if (step === 3) {
      return <InvoiceWalletList />;
    }

    if (step === 4) {
      return <InvoiceSummary />;
    }
  }

  return <InvoiceSummary />;
};
